/* Стили блока с анимацией порядка приема препараторв */
import {throttle} from "../modules/Util";

const $proccessAnimation = $('.js-proccess-animation');

if ($proccessAnimation.length) {
    App.D.ready(function(){
        if (App.mobile || App.W.width() < 1024){
            return;
        } else {
            $proccessAnimation.each(function(index) {
                const $proccessAnimation = $(this);

                if ($proccessAnimation.length) {
                    $proccessAnimation.find($('.plane-wrapper')).attr('id', 'plane-' + index);
                    $proccessAnimation.find($('.path-figure')).attr('id', 'path-' + index);
                }

                motion(index, 0);
            });

            App.W.on('scroll', throttle(motionAnimation, 30));
        }
    });
}


function motionAnimation() {
    const scrollTop = App.W.scrollTop();
    const $animationSvg = $proccessAnimation.find('.js-animation-svg');

    $animationSvg.each(function (index, el) {
        const $currSvgItem = $(el);
        const animationWrapTop = $currSvgItem.offset().top;
        const animationWrapEnd = $currSvgItem.outerHeight() - 200;

        if (scrollTop >= animationWrapTop - 300) {
            const scrollAnim = (scrollTop - (animationWrapTop - 300)) / animationWrapEnd;

            motion(index, scrollAnim);
            $('.js-proccess-overlay').css({top: `${scrollAnim * 100}%`});
        }
    });
}


function motion(index, position) {
    gsap.to('#plane-' + index, {
        duration: 0,
        ease: "power1.inOut",
        motionPath:{
            path: '#path-' + index,
            align: '#path-' + index,
            yoyo: true,
            autoRotate: true,
            start: 0,
            end: position,
            alignOrigin: [0.5, 0.5]
        }
    });

    $('.js-animation-svg').eq(index).find('.white-rect').attr('y', `${position * 100}%`);
}